// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.title {
  font-size: 19px;
  font-weight: bold;
  color: var(--ion-color-primary);
  line-height: 130%;
  padding: var(--d-spacing-double);
}

.language-option {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: var(--d-spacing-single);
}

ion-radio-group {
  display: flex;
  flex-direction: column;
  padding-bottom: calc(var(--d-spacing-double) * 2);
}

ion-radio {
  padding: var(--d-spacing-single);
}`, "",{"version":3,"sources":["webpack://./src/app/chatbot/buddy/buddy-language/buddy-language.component.scss","webpack://./src/mixins.scss"],"names":[],"mappings":"AAEA;ECDI,eAAA;EACA,iBAAA;EACA,+BAAA;EACA,iBAAA;EDAF,gCAAA;AAEF;;AACA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,gCAAA;AAEF;;AACA;EACE,aAAA;EACA,sBAAA;EACA,iDAAA;AAEF;;AACA;EACE,gCAAA;AAEF","sourcesContent":["@import \"src/mixins\";\n\n.title {\n  @include h1-style;\n  padding: var(--d-spacing-double);\n}\n\n.language-option {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  padding: var(--d-spacing-single);\n}\n\nion-radio-group {\n  display: flex;\n  flex-direction: column;\n  padding-bottom: calc(var(--d-spacing-double) * 2);\n}\n\nion-radio {\n  padding: var(--d-spacing-single);\n}\n","@mixin h1-style {\n    font-size: 19px;\n    font-weight: bold;\n    color: var(--ion-color-primary);\n    line-height: 130%;\n}\n\n@mixin p1-style {\n    font-size: 16px;\n    font-weight: 500;\n    color: var(--ion-color-primary);\n    line-height: 150%;\n}\n\n@mixin p1-berry-style {\n    font-size: 16px;\n    font-weight: 500;\n    color: var(--ion-color-secondary);\n    line-height: 150%;\n}\n\n@mixin p1-white-style {\n    font-size: 16px;\n    font-weight: 500;\n    color: white;\n    line-height: 150%;\n}\n\n@mixin p2-style {\n    font-size: 13px;\n    font-weight: 500;\n    color: var(--ion-color-primary);\n    line-height: 150%;\n}\n\n@mixin p2-berry-style {\n    font-size: 13px;\n    font-weight: 500;\n    color: var(--ion-color-secondary);\n    line-height: 150%;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
